<wk-panel-icon-phone />
<hr />
<wk-panel-icon-cellphone />
<hr />
<wk-panel-icon-email />
<hr />
@if (isUsersPanelIconsVisible) {
    <wk-panel-icon-users />
    <hr />
}
<wk-panel-icon-client-code />
